module.exports = __webpack_public_path__ + "img/info.dc779c7c.svg";